<template>
    <div>
        <div class="d-flex">
            <v-btn text @click="expanded = !expanded">
                <v-icon left dark>{{ expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                <span class="textColor font-weight-bold">{{ title }}</span>
            </v-btn>
            <slot name="title.append"></slot>
        </div>

        <v-divider class="my-2" />
        <v-expand-transition>
            <div v-show="expanded">
                <slot></slot>
            </div>
        </v-expand-transition>
    </div>
</template>
<script>
export default {
    props: ['title'],
    data() {
        return {
            expanded: false
        };
    }
};
</script>
